import { ImageProcessor } from "./components/image-processor";

export default function App() {
  return (
    <div className="size-full">
      <ImageProcessor />
    </div>
  );
}